import { createAppContainer } from './AppContainer.js';
import { Env } from './env.js';

const debugMode = Env.VITE_DEBUG_MODE ?? Env.MODE === 'development';
const isLocalhost = ['127.0.0.1', 'localhost'].includes(globalThis.location.hostname);
const emulators =
  isLocalhost && (Env.VITE_USE_FIREBASE_EMULATORS || false)
    ? {
        // Firebase emulators started by scripts/start-dev.sh bind explicitly to 127.0.0.1.
        // Using localhost can resolve to ::1 in some browser contexts and break auth/network calls.
        storage: { host: '127.0.0.1', port: Env.VITE_FIREBASE_STORAGE_PORT },
        firestore: { host: '127.0.0.1', port: Env.VITE_FIREBASE_FIRESTORE_PORT },
        auth: { host: '127.0.0.1', port: Env.VITE_FIREBASE_AUTH_PORT, disableWarnings: true },
      }
    : false;

export const $app = createAppContainer({
  firebase: {
    app: Env.FIREBASE,
    performance: { dataCollectionEnabled: true, instrumentationEnabled: true },
    firestore: { ignoreUndefinedProperties: true, enableLocalCache: true },
    emulators,
    // insaneDebug: false,
  },
  debugMode,
  isLocalhost,
});
